import { memo, useState } from 'react'
import { Menu, MenuButton, MenuList, MenuItem, MenuDivider, IconButton, Box } from '@chakra-ui/react'

import { QuestionWithNotification } from 'components/icons'

import SupportButton from './components/SupportButton'
import PatchNotesButton from './components/PatchNotesButton'
import { usePathname } from 'next/navigation'

function InfoButton({
  buttonVariant = 'ghost',
  buttonColor = 'gray',
  iconColor = 'auto',
}: {
  buttonVariant?: string
  buttonColor?: string
  iconColor?: string
}) {
  const [haveNotification, setHaveNotification] = useState(false)
  const pathname = usePathname()

  if (pathname.includes('/app-cidadao')) {
    return <></>
  }

  return (
    <Menu>
      <MenuButton
        as={IconButton}
        icon={
          <QuestionWithNotification boxSize={6} variant={haveNotification ? 'filled' : 'outline'} color={iconColor} />
        }
        variant={buttonVariant}
        colorScheme={buttonColor}
      >
        <Box bg="red" w="100px" h="100px" pos="absolute" />
      </MenuButton>
      <MenuList zIndex={500} shadow="md">
        <MenuItem p={0} rounded="md">
          <SupportButton />
        </MenuItem>
        <MenuDivider />
        <MenuItem p={0} rounded="md">
          <PatchNotesButton setHaveNotification={setHaveNotification} />
        </MenuItem>
      </MenuList>
    </Menu>
  )
}

export default memo(InfoButton)
